import React from "react";
import { Text } from "react-native";
import { router } from "expo-router";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import UnlockUsersBaseCard from "../../Base/UnlockUsersBaseCard";

import {
  PROFILE_ATTRIBUTE_REQUIREMENT,
  ProfileCompletionScore,
  countFilledProfileAttributes,
  getProfileAttributesScore,
} from "@/utils/unlockingStage";
import { UserProfile } from "@/schemas/user/profile";

type Props = {
  userProfile: UserProfile;
  onAction: () => void;
};

function UnlockUsersProfileDetailsCard({
  userProfile,
  onAction,
}: Props): React.JSX.Element {
  const minAttributeCount = PROFILE_ATTRIBUTE_REQUIREMENT.MIN_COUNT;

  const filledProfileAttributesCount =
    countFilledProfileAttributes(userProfile);
  const isCompleted = filledProfileAttributesCount >= minAttributeCount;

  return (
    <UnlockUsersBaseCard
      iconComponent={
        <MaterialCommunityIcons
          name={"account-details-outline"}
          size={36}
          color="black"
        />
      }
      title="Profile Details"
      description={`Add at least ${minAttributeCount} profile details`}
      totalScore={ProfileCompletionScore.PROFILE_ATTRIBUTES_DETAILS}
      earnedScore={getProfileAttributesScore(userProfile)}
      statusComponent={
        <Text>
          {isCompleted
            ? "Completed"
            : `${Math.min(filledProfileAttributesCount, minAttributeCount)}/${minAttributeCount} added`}
        </Text>
      }
      isCompleted={isCompleted}
      onPressActionButton={() => {
        onAction();
        router.push("/(main)/account/home");
      }}
    />
  );
}

export default UnlockUsersProfileDetailsCard;
